import { Star, ArrowUpRight, PenLine } from "lucide-react";
import Reveal from "@/components/Reveal";
import { COMPANY, REVIEWS, RATING } from "@/data/site";

const Stars = ({ size = 18 }) => (
  <span className="flex gap-0.5" aria-label={`Rated ${RATING.score} out of 5`}>
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={size} className="text-[#FBBF24]" fill="#FBBF24" />
    ))}
  </span>
);

const ReviewsSection = () => (
  <section id="client-reviews" data-testid="reviews-section" className="relative bg-mist text-navy dot-grid-light">
    <div className="max-w-8xl mx-auto px-6 lg:px-12 py-24 lg:py-36">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-brand font-medium">Client Reviews</p>
          </Reveal>
          <Reveal delay={0.08}>
            <div className="mt-6 flex items-end gap-4">
              <span className="font-display font-black text-7xl lg:text-8xl leading-none tracking-tighter" data-testid="reviews-score">
                {RATING.score}
              </span>
              <div className="pb-2">
                <Stars size={20} />
                <p className="mt-2 text-navy/60 text-sm">Based on Google reviews</p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.16}>
            <h2 className="mt-8 font-display font-extrabold tracking-tighter leading-[1.05] text-3xl md:text-4xl">
              Rated by the businesses <span className="text-brand">we work with.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.24}>
            <div className="mt-8 flex flex-wrap gap-4">
              <a
                href={COMPANY.mapsLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-read-all"
                className="inline-flex items-center gap-2 bg-brand hover:bg-navy text-white font-semibold px-7 py-3.5 rounded-full transition-colors duration-300"
              >
                Read All Reviews <ArrowUpRight size={17} />
              </a>
              <a
                href={COMPANY.mapsLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-write"
                className="inline-flex items-center gap-2 border border-navy/20 text-navy hover:border-brand hover:text-brand font-semibold px-7 py-3.5 rounded-full transition-colors duration-300"
              >
                <PenLine size={16} /> Write a Review
              </a>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={0.08 * i}>
              <figure
                data-testid={`review-card-${i}`}
                className="flex flex-col h-full bg-white border border-navy/10 rounded-3xl p-7 hover:border-brand/40 hover:-translate-y-1 transition-[border-color,transform] duration-300"
              >
                <Stars size={15} />
                <blockquote className="mt-5 text-navy/80 leading-relaxed flex-1">"{r.text}"</blockquote>
                <figcaption className="mt-6 pt-5 border-t border-navy/10">
                  <p className="font-display font-bold text-navy">{r.name}</p>
                  <p className="text-navy/50 text-xs mt-0.5">{r.meta}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default ReviewsSection;
